import { useTour } from "@reactour/tour";
//#region src/modules/core/hooks/useTour.tsx
var useTour$1 = () => {
	return useTour();
};
//#endregion
export { useTour$1 as useTour };
